import React, { Component, createRef } from 'react';
import { Label, FormGroup } from 'reactstrap';
import Select from '../common/Select';
import { Row, Col } from 'reactstrap';
import { injectIntl } from 'react-intl';
import StreamTDSHint from './StreamTDSHint';
import _ from 'lodash';
import { getErrorMessage, hasErrorInScript } from './formErrorHelper';
import { FMessage } from '../../hoc/IntlComponents';
import { debounce } from '../../utils/utils';
import api from '../../services/ApiService';
import { string, number, oneOfType } from 'prop-types';

class StreamTDSDefaultStream extends Component {
  static propTypes = {
    flow: oneOfType([string, number]),
  };
  static defaultProps = {
    flow: '',
  };
  constructor(props) {
    super(props);
    this.state = {
      findedFlows: [],
    };
    this._alertRefs = {
        [props.errorPath]: createRef(),
    };
  }
  onLoadFlowInfo = () => this.setState({flowLoad: true});
  onLoadingFlowInfo = () => this.setState({});
  componentDidMount() {
    const {flow, getFlowsInfo, saveRef, changePath, errorPath, scrKey} = this.props;
    if(!!flow) {
      getFlowsInfo(flow, this.onLoadingFlowInfo, this.onLoadFlowInfo);
    }
    if(changePath === 'flow') {
      saveRef(false, errorPath, this._alertRefs[errorPath]);
    } else {
      saveRef(true, errorPath, this._alertRefs[errorPath], scrKey);
    }
  }
  hasFlowInfo = id => {
    const { flowsInfo } = this.props;
    return _.find(flowsInfo, ['id', id]);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const {flow, getFlowsInfo, changePath} = this.props;
    if(changePath === 'flow' && !flow && !!nextProps.flow) {
      if(!this.hasFlowInfo(nextProps.flow)) {
        getFlowsInfo(nextProps.flow, this.onLoadingFlowInfo, this.onLoadFlowInfo);
      }
    }
  }
  hasError = () => {
    const {errors, scrKey, changePath, errorPath} = this.props;
    if(changePath === 'flow') {
      return _.get(errors, errorPath);
    }
    return hasErrorInScript({
      errors,
      errorPath,
      scrKey,
    });
  }
  getId = () => {
    const {changePath, scrKey, errorPath} = this.props;
    if(changePath === 'flow') {
      return errorPath;
    } else {
      return `${errorPath}${scrKey}`;
    }
  }

  getSavedFlowOption = () => {
    const { flow } = this.props;
    const findedFlowOption = [];
    if(flow) {
      const findedFlow = this.hasFlowInfo(flow);
      if(findedFlow) {
        findedFlowOption.push(findedFlow);
      }
    }
    return findedFlowOption;
  }

  getOptions = (input, cb) => {
    const { defaultStreams, flowsInfo } = this.props;
    const q = input.trim();
    const params = {};

    if (q.length > 2) {
      params.title = q;
      api.streams.getStreams(params)
        .then(data => data.items)
        .then(options => {
          const prepared = this.prepareOptions(options);
          this.setState(prevState => ({
            ...prevState,
            findedFlows: prepared,
          }));
          return cb(null, { options: prepared });
        })
        .catch(error => cb(error, null));
    } else {
      cb(null, { options: this.prepareOptions([...defaultStreams, ...flowsInfo]) });
    }
  };

  filterBlockedOptions = options => {
    const excludedIds = this.getAlreadyUsedDefaultStreamIds();
    return options.filter(option => !option.is_block && !excludedIds.includes(option.id));
  };

  getAlreadyUsedDefaultStreamIds = () => {
    const {
      scripts,
      inScripts,
      scrKey,
    } = this.props;

    const ids = [];
    if(inScripts) {
      scripts.forEach((script, scriptIndex) => {
        if(script.r && scriptIndex !== scrKey) {
          ids.push(+script.r);
        }
      });
    }
    return _.uniq(ids);
  }

  filterUniqIds = options => {
    const ids = _.uniq(options.map(option => option.id));
    return ids.map(id => options.find(option => option.id === id));
  }

  prepareOptions = options =>
    _.orderBy(this.filterBlockedOptions(this.filterUniqIds(options)
      .map(option => ({
      ...option,
      value: option.id,
      label: option.title,
    }))), ['value'], ['desc']);

  findFlowInAsyncCashe = value => this.state.findedFlows.find(item => item.id === value);

  render() {
    const {
      changePath,
      defaultStreams,
      onSelectChange,
      flow,
      offers,
      inScripts,
      flowsInfo,
      getFlowsInfo,
      offersInfo,
      scrKey,
      errorPath,
      notFoundOffersInStreams,
      setFlowInfo,
      getOffersInfo,
    } = this.props;
    const { flowLoad } = this.state;
    const hasError = this.hasError();
    return (
      <Row>
        <Col lg="6" xs='10'>
          <div
            id={this.getId()}
            className='stream-tds-flow'
            ref={this._alertRefs[errorPath]}
          >
            {
              defaultStreams &&
                <FormGroup className={hasError ? 'has-error' : ''}>
                  <Label htmlFor={changePath}>
                    <FMessage id="streamTDS.flow"/>
                  </Label>
                  <Select
                    asyncSearch
                    id={changePath}
                    name={changePath}
                    clearable={true}
                    value={flow.toString()}
                    onChange={(selected) => {
                      if(selected) {
                        onSelectChange(changePath, selected.value);
                        const innerFlowInfo = this.findFlowInAsyncCashe(+selected.value);
                        if(!this.hasFlowInfo(+selected.value) && !innerFlowInfo) {
                          getFlowsInfo(selected.value, this.onLoadingFlowInfo, this.onLoadFlowInfo);
                          getOffersInfo(selected.offer_id, this.onLoadingFlowInfo, this.onLoadFlowInfo);
                        } else {
                          if(innerFlowInfo) {
                            setFlowInfo(innerFlowInfo);
                            getFlowsInfo('', this.onLoadingFlowInfo, this.onLoadFlowInfo);
                            getOffersInfo(innerFlowInfo.offer_id, this.onLoadingFlowInfo, this.onLoadFlowInfo);
                          }
                        }
                      } else {
                        onSelectChange(changePath, '');
                        getFlowsInfo('', this.onLoadingFlowInfo, this.onLoadFlowInfo);
                      }
                    }}
                    autoBlur={true}
                    autoload={false}
                    loadOptions={this.getOptions}
                    options={this.prepareOptions([...defaultStreams, ...flowsInfo])}
                  />
                  {hasError && <small className="form-text">{getErrorMessage(errorPath)}</small>}
                </FormGroup>
            }
          </div>
        </Col>
        {
          flow && flowLoad ?
            <StreamTDSHint
              offers={offers}
              flow={flow}
              inScripts={inScripts}
              defaultStreams={defaultStreams}
              flowsInfo={flowsInfo}
              offersInfo={offersInfo}
              scrKey={scrKey}
              notFoundOffersInStreams={notFoundOffersInStreams}
            /> : null
          }
      </Row>
    );
  }
}

export default injectIntl(StreamTDSDefaultStream);